// removed by extract-text-webpack-plugin
module.exports = {"actionBar":"_1djsubvmuw2MiJcTF8Txxu","actionBarThemeDefault":"_2A0F-0GqVXfuWdrCfchqWN","actionBarThemePrimary":"b4G3RggOVJkzp0aDIG8AQ","actionBarThemeInfo":"hxmFIIAlUI4iLyV85qi0D","actionBarThemeSuccess":"_3gRu1DOiOya6fa9GBC-f41","actionBarThemeWarning":"_3CXVa21BE2op8--ZgVhR5h","actionBarThemeDanger":"_3T9BSy7Seqcfpubr_dsIZD"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/menus/action-bar-menu.scss
// module id = 101
// module chunks = 0